// plugins/imagePreview.js
import Vue from 'vue'
import { Image as ElImage } from 'element-ui'

const Constructor = Vue.extend({
    components: { ElImage },
    props: {
        srcList: {
            type: Array,
            required: true
        },
        startIndex: {
            type: Number,
            default: 0
        }
    },
    template: `
    <el-image
      ref="img"
      style="width:0;height:0;opacity:0;position:absolute;"
      :src="srcList[startIndex]"
      :preview-src-list="srcList"
    />
  `
})

// 注册全局方法
Vue.prototype.$imagePreview = function (srcList, startIndex = 0) {
    if (!srcList || srcList.length === 0) return

    const instance = new Constructor({
        propsData: {
            srcList: Array.isArray(srcList) ? srcList : [srcList],
            startIndex
        }
    })
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)

    // 等待图片渲染出来后再点击
    const tryClick = () => {
        const img = instance.$refs.img?.$el?.querySelector('img')
        if (img) {
            img.click()
            // // 点击后稍等清理DOM，防止累积
            // setTimeout(() => {
            //     instance.$destroy()
            //     instance.$el.remove()
            // }, 1000)
        } else {
            setTimeout(tryClick, 50)
        }
    }

    Vue.nextTick(tryClick)
}
